<div class="page-content">
    <div class="container-fluid">
        <p>form-checks works!</p>
    </div>
</div>